module.exports = __webpack_public_path__ + "img/dark.9c618376.png";